import { Component, OnInit } from '@angular/core';
import { HostListener } from '@angular/core';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  //@HostListener allows us to also guard against browser refresh, close, etc.

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    event.returnValue = "Please make sure to submit the data for each employee. You must receive a confirmation verifying submission of data.";
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts